<template>
  <div id="chooseGoods">
    <!-- 面包屑 -->
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="back" href="javascript:;">选择商品</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>商品列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 按钮区 -->
    <div class="box">
      <div>
        <el-button type="primary" @click="addRefundGoods" v-if="goodsStyle == 2"
          >增加进货退货商品</el-button
        >
        <el-button type="primary" @click="addRefundGoods" v-if="goodsStyle == 1"
          >增加进货商品</el-button
        >
        <el-button type="primary" @click="addRefundGoods" v-if="goodsStyle == 3"
          >增加盘点商品</el-button
        >
        <el-button type="primary" @click="addRefundGoods" v-if="goodsStyle == 4"
          >增加调拨商品</el-button
        >
        <span class="checked"
          ><el-checkbox v-model="totalClick" @change="totalChecked"></el-checkbox
          >全选</span
        >
        <el-button type="primary" plain @click="back">取消</el-button>
        <el-button
          type="primary"
          @click="settleMent"
          v-if="goodsStyle == 1 || goodsStyle == 2"
          >结算</el-button
        >
        <el-button type="primary" @click="confirmChangeGoods" v-if="goodsStyle == 4"
          >调拨</el-button
        >
        <!-- <el-button
          type="primary"
          plain
          @click="addGoods"
          v-if="goodsStyle == 1 || goodsStyle == 2"
          >新增商品</el-button
        > -->
        <el-button type="primary" @click="confirmAddGoods" v-if="goodsStyle == 3"
          >确认选择</el-button
        >
      </div>
      <div style="margin-right: 30px">
        <!-- <el-select size="small" v-model="synthesisOrderType" placeholder="排序">
              <el-option v-for="item in synthesisOrderTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-select size="small" v-model="repositoryId" placeholder="入库状态">
              <el-option v-for="item in repositoryList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
            </el-select> -->
        <!-- <el-input size="small" placeholder="输入商品..." v-model="goodsName" style="width: 200px;" clearable></el-input> -->
        <!-- <el-button size="small" @click="search" type="primary">搜索</el-button> -->
      </div>
    </div>
    <!-- 商品区 -->
    <div class="searchGroup">
      <div v-if="confirmChooseList.length !== 0">
        <div v-for="(item, index) in confirmChooseList" :key="index">
          <div class="flex-betweens">
            <div class="goodsBox">
              <div>
                <span class="commidityClick"
                  ><el-checkbox
                    @change="commidityClick(item, index)"
                    v-model="item.click"
                  ></el-checkbox
                ></span>
                <img v-if="item.goodsImage" :src="item.goodsImage" alt class="img" />
                <img
                  v-if="!item.goodsImage"
                  src="@/assets/icon/defaultPic.png"
                  alt
                  class="img"
                />
              </div>
              <div class="flex-between">
                <div>{{ item.goodsName }}</div>
                <div>
                  <span style="color: #ff4649" v-if="goodsStyle == 1"
                    >进货价：￥{{ item.takePrice ? item.takePrice : 0 }}/{{
                      item.goodsUnit
                    }}</span
                  >
                  <span style="color: #ff4649" v-else
                    >￥{{ item.takePrice ? item.takePrice : 0 }}/{{
                      item.goodsUnit
                    }}</span
                  >
                  <span class="color">规格：{{ item.valueContent }}</span>
                  <span class="color" v-if="item.isInfiniteStock == 0"
                    >可用库存：{{ item.qrcTotalStockCount }}</span
                  >
                  <span class="color" v-if="item.isInfiniteStock == 1">无限库存</span>
                  <span
                    class="color"
                    v-if="
                      item.maximumTotalStockCount &&
                      item.qrcTotalStockCount > item.maximumTotalStockCount
                    "
                    >库存：
                    <div class="highStock">高</div></span
                  >
                  <span
                    class="color"
                    v-if="
                      item.minimumTotalStockCount &&
                      item.qrcTotalStockCount < item.minimumTotalStockCount
                    "
                    >库存：
                    <div class="lowStock">低</div></span
                  >
                </div>
              </div>
            </div>
            <div class="flex-center">
              <div>￥{{ (item.goodsNum * item.takePrice).toFixed(2) }}</div>
              <el-input-number
                v-model="item.goodsNum"
                size="small"
                @change="handleChange(item)"
                :min="0"
                :max="maxNum"
                type="number"
                style="margin-left: 30px"
              ></el-input-number>
            </div>
          </div>
        </div>
        <div v-if="goodsStyle == 1 || goodsStyle == 2" class="flex-centers">
          {{ confirmChooseListLength }}种 ，￥{{ totalMony.toFixed(2) }}
        </div>
      </div>
      <div v-if="confirmChooseList.length == 0" class="center">暂无商品</div>
    </div>
    <div class="mask" v-show="mask"></div>
    <!-- 商品列表 -->
    <div class="goods" v-show="goodsDialogVisible">
      <div class="goods-header">
        <el-input
          size="small"
          placeholder="输入商品..."
          v-model="synthesisSearch"
          style="width: 200px"
        ></el-input>
        <el-button size="small" @click="searchGoods" type="primary">搜索</el-button>
        <span class="scanner">扫码枪录入</span>
        <el-switch
          v-model="scanSwitch"
          active-color="#409EFF"
          inactive-color="#ccc"
          @change="scanSwithChange"
        ></el-switch>
        <img src="@/assets/icon/close.png" class="closeImg" @click="closeImg" />
      </div>
      <div class="flex-start">
        <div class="left">
          <div
            v-for="(item, index) in goodsCategoryList"
            :key="index"
            @click="chooseProducts(item, index)"
            :class="indexNumber !== index ? 'category' : 'navBlock_click'"
          >
            {{ item.categoryName }}
          </div>
          <!-- <el-tabs v-model="goodsCategoryId" type="card" tab-position="tabPosition" @tab-click="chooseProducts(item, index)" :class="indexNumber!== index? 'category' : 'navBlock_click'">
                    <el-tab-pane 
                      :key="item.categoryName"
                      v-for="item in goodsCategoryList"
                      :label="item.categoryName"
                      :id="item.goodsCategoryId"
                    >
                    </el-tab-pane>
                </el-tabs> -->
        </div>
        <div class="right">
          <div v-if="goodsList.length > 0">
            <div
              v-for="(item, index) in goodsList"
              :key="index"
              @click="chooseLists(item, index)"
            >
              <div class="flex-betweens">
                <div class="flex-start detail-box">
                  <div>
                    <img v-if="item.goodsImage" :src="item.goodsImage" alt class="img" />
                    <img
                      v-if="!item.goodsImage"
                      src="@/assets/icon/defaultPic.png"
                      alt
                      class="img"
                    />
                  </div>
                  <div class="flex-between">
                    <div>{{ item.goodsName }}</div>
                    <div>
                      <span style="color: #ff4649"
                        >￥{{ item.takePrice ? item.takePrice : 0 }}</span
                      >
                      <span class="color">规格：{{ item.valueContent }}</span>
                      <span class="color" v-if="item.isInfiniteStock == 0"
                        >可用库存：{{ item.qrcTotalStockCount }}</span
                      >
                      <span class="color" v-if="item.isInfiniteStock == 1">无限库存</span>
                      <span
                        class="color"
                        v-if="
                          item.maximumTotalStockCount &&
                          item.qrcTotalStockCount > item.maximumTotalStockCount
                        "
                        >库存：
                        <div class="highStock">高</div></span
                      >
                      <span
                        class="color"
                        v-if="
                          item.minimumTotalStockCount &&
                          item.qrcTotalStockCount < item.minimumTotalStockCount
                        "
                        >库存：
                        <div class="lowStock">低</div></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mt20">暂无数据</div>
        </div>
      </div>
    </div>
    <!-- 单个商品信息 -->
    <div class="goods-detail" v-show="dialogVisible">
      <div class="flex-betweens">
        <div>
          <img
            v-if="goodList.goodsImage"
            :src="goodList.goodsImage"
            class="goodsPic"
            alt
          />
          <img
            v-if="!goodList.goodsImage"
            src="@/assets/icon/defaultPic.png"
            alt
            class="goodsPic"
          />
        </div>
        <div>
          <div class="goodsTitle">{{ goodList.goodsName }}</div>
          <div class="goodsDetail">
            <div class="mt5">条形码：{{ goodList.goodsBarCode }}</div>
            <div class="mt5" v-if="goodList.isInfiniteStock == 0">
              {{ goodsStyle == 3 ? "账面数量：" : "库存数量："
              }}{{ goodList.qrcTotalStockCount }}{{ goodList.goodsUnit }}
            </div>
            <div class="mt5" v-if="goodList.isInfiniteStock == 1">
              {{ goodsStyle == 3 ? "账面数量：" : "库存数量：" }}无限库存
            </div>
            <div class="mt5" v-show="referPrice">
              参考进货价：￥{{ goodList.takePrice ? goodList.takePrice : 0 }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt20">
        <span class="text-color">选择数量</span>
        <!-- :min="0" :max="goodList.qrcTotalStockCount" -->
        <el-input-number
          v-model="goodsNum"
          @change="handleChanges"
          size="mini"
          label="描述文字"
          v-if="goodsStyle == 3 || goodsStyle == 1"
        ></el-input-number>
        <el-input-number
          v-model="goodsNum"
          @change="handleChanges"
          size="mini"
          label="描述文字"
          :min="0"
          :max="goodList.qrcTotalStockCount"
          v-else
        ></el-input-number>
      </div>
      <div class="mt20" v-show="isShow">
        <span class="text-color">进货价格</span>
        <el-input
          v-model="goodList.takePrice"
          placeholder="请输入进货价格"
          style="width: 400px"
          @blur="takePriceBlur"
          type="number"
        ></el-input>
      </div>
      <div class="mt20 ml69">
        <el-button type="primary" @click="confirmAdd">完成</el-button>
        <!-- <el-button type="primary" plain>继续扫描</el-button> -->
      </div>
    </div>
    <!-- 分页 -->
    <!-- <div v-if="goodsList.length > 0" style="position: absolute; top: 900px;right: 70px;">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="queryInfo.pageNum"
          :page-size="queryInfo.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
    </div> -->
  </div>
</template>

<script>
import {
  repositoryGoodsDetailList,
  goodslistTotalNumundGoods,
  repositoryList,
  goodsCategoryLists,
  updateTakePrice,
} from "../api";
import { createScannerInput } from "@/utils/scannerInput";
export default {
  data() {
    return {
      totalClick: false,
      repositoryId: "",
      repositoryList: [],
      synthesisOrderType: "",
      synthesisOrderTypeList: [
        { value: "", name: "全部排序" },
        { value: 0, name: "创建日期" },
        { value: 1, name: "编号" },
        { value: 2, name: "名称" },
      ],
      synthesisSearch: "",
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      goodsList: [],
      status: "",
      shopStoreId: "",
      list: [],
      goodsDialogVisible: false,
      dialogVisible: false,
      mask: false,
      scanSwitch: false,
      goodsNum: 1,
      goodsCategoryList: [],
      indexNumber: 0, //左侧导航栏的索引
      chooseList: [],
      confirmChooseList: [],
      goodList: {},
      takePrice: "",
      status: "",
      barCode: "",
      codeMsg: "",
      goodsStyle: "",
      tabPosition: "left",
      maxNum: 9999999999999,
      goodsName: "",
      goodsCategoryId: "",
      isShow: true,
      totalMony: 0,
      referPrice: true,
      confirmChooseListLength: 0,
      cannotClear: "",
    };
  },
  created() {
    // console.log(localStorage.getItem("shopStoreId"))
    this.confirmChooseList = JSON.parse(
      localStorage.getItem("confirmChooseList") || "[]"
    );
    console.log(this.confirmChooseList, "this.confirmChooseList");
    this.goodsStyle = localStorage.getItem("goodsStyle");
    if (this.goodsStyle == 1) {
      this.getGoodsCategoryList();
    } else {
      this.getGoodsCategoryList(2);
    }
    var bool = this.confirmChooseList.every((item) => {
      return item.click == true;
    });
    if (bool && this.confirmChooseList.length !== 0) {
      this.totalClick = true;
    }
    if (this.goodsStyle == 4 || this.goodsStyle == 3) {
      this.isShow = false;
    }
    if (this.goodsStyle == 3) {
      this.referPrice = false;
    }
    console.log(this.cannotClear, "cannotClear");
  },
  mounted() {
    this.scanSwitch = localStorage.getItem("addGoodsSwith") === "true" ? true : false;
    if (this.scanSwitch == true) {
      this.addScanSwitchGoods();
    } else {
      document.onkeydown = null;
    }
    console.log(this.confirmChooseList);
    this.confirmChooseList.forEach((item) => {
      if (item.click == true) {
        this.totalMony += item.takePrice * item.goodsNum;
      }
    });
    var trueList = this.confirmChooseList.filter((item) => {
      return item.click == true;
    });
    console.log(trueList, "trueList");
    this.confirmChooseListLength = trueList.length;
  },
  watch: {
    scanSwitch(val) {
      this.scanSwitch = val;
      if (this.scanSwitch == true) {
        this.addScanSwitchGoods();
      } else {
        document.onkeydown = null;
      }
    },
  },
  beforeDestroy() {
    console.log(this.cannotClear);
    if (this.cannotClear == 1) {
      this.cannotClear = 0;
      console.log(
        localStorage.confirmChooseList,
        localStorage.chooseList,
        this.cannotClear
      );
    } else {
      console.log(123);
      localStorage.removeItem("confirmChooseList");
      localStorage.removeItem("chooseList", this.cannotClear);
      this.cannotClear = 0;
    }
  },
  // computed: {
  //     totalMony: {
  //         get() {
  //           return this.totalMony;
  //         },
  //         set(val) {
  //             console.log(val)
  //           this.totalMony = val;
  //         }
  //     }
  // },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 搜索
    search() {
      var arr = this.confirmChooseList.filter((item) => {
        return item.goodsName == this.goodsName;
      });
      this.$nextTick(() => {
        if (arr.length == 0 && this.goodsName == "") {
          this.confirmChooseList = JSON.parse(
            localStorage.getItem("confirmChooseList") || "[]"
          );
        } else {
          this.confirmChooseList = arr;
        }
      });
    },
    searchGoods() {
      console.log(this.goodsCategoryList);
      if (this.goodsCategoryList.length == 0) {
        this.$message.error("该仓库下暂无商品，请换一个仓库");
        return;
      }
      if (this.goodsStyle == 1) {
        this.getRepositoryGoodsDetailList(this.synthesisSearch, "", this.goodsCategoryId);
      } else {
        this.getRepositoryGoodsDetailList(
          this.synthesisSearch,
          "",
          this.goodsCategoryId,
          2
        );
      }
    },
    // 全选
    totalChecked(item) {
      console.log(item);
      if (this.confirmChooseList.length == 0) {
        this.totalClick = false;
        return;
      }
      this.confirmChooseList.forEach((element) => {
        element.click = this.totalClick;
      });
      if (this.totalClick) {
        this.confirmChooseList.forEach((element) => {
          this.list.push(element);
          console.log(this.list, "全选");
        });
        this.totalMony = 0;
        this.confirmChooseList.forEach((item) => {
          if (item.click == true) {
            this.totalMony += item.takePrice * item.goodsNum;
          }
        });
        this.confirmChooseListLength = this.confirmChooseList.length;
      } else {
        this.list = [];
        this.totalMony = 0.0;
        this.confirmChooseListLength = 0;
      }
      localStorage.setItem("confirmChooseList", JSON.stringify(this.confirmChooseList));
      localStorage.setItem("chooseList", JSON.stringify(this.list));
    },
    // 商品是否选中
    commidityClick(item, index) {
      console.log(item, index);
      var arr = this.confirmChooseList;
      console.log(item.click, "商品是否选中状态");
      if (item.click == false) {
        this.totalClick = false;
        for (let i in this.list) {
          if (this.list[i].productId == item.productId) {
            this.list.splice(i, 1);
          }
          this.totalMony = 0;
          var trueList = this.confirmChooseList.filter((item) => {
            return item.click == true;
          });
          this.confirmChooseListLength = trueList.length;
          this.confirmChooseList.forEach((item) => {
            if (item.click == true) {
              this.totalMony += item.takePrice * item.goodsNum;
            }
          });
        }
        console.log(this.list, "false");
      } else {
        this.totalClick = arr.every((item1) => {
          return item1.click;
        });
        this.list.push(item);
        console.log(this.list, "true");
        this.totalMony = 0;
        var trueList = this.confirmChooseList.filter((item) => {
          return item.click == true;
        });
        this.confirmChooseListLength = trueList.length;
        this.confirmChooseList.forEach((item) => {
          if (item.click == true) {
            this.totalMony += item.takePrice * item.goodsNum;
          }
        });
      }
      localStorage.setItem("confirmChooseList", JSON.stringify(this.confirmChooseList));
      localStorage.setItem("chooseList", JSON.stringify(this.list));
      //因为goodslist click值变化 界面checkbox状态不变
      this.confirmChooseList = "";
      this.confirmChooseList = arr;
      //
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999,
        // shopStoreId: this.shopStoreId
      }).then((res) => {
        if (res.code == 1) {
          this.repositoryList = res.data;
          this.repositoryList.unshift({ repositoryName: "全部仓库", repositoryId: "" });
        }
      });
    },
    // 获取商品列表
    getRepositoryGoodsDetailList(
      synthesisSearch,
      synthesisOrderType,
      goodsCategoryId,
      queryType
    ) {
      repositoryGoodsDetailList({
        isManager: 1,
        queryType: queryType,
        shopStoreId: localStorage.getItem("checkShopStoreId"),
        pageNo: 1,
        row: 99999,
        synthesisSearch: synthesisSearch,
        synthesisOrderType: synthesisOrderType,
        repositoryId: localStorage.getItem("checkRepositoryId"),
        goodsCategoryId: goodsCategoryId,
      }).then((res) => {
        if (res.code == 1) {
          this.goodsList = res.data;
          this.goodList = this.goodsList[0];
          for (var i in this.goodsList) {
            this.goodsList[i].goodsNum = 1;
          }
          goodslistTotalNumundGoods({
            isManager: 1,
            queryType: queryType,
            shopStoreId: localStorage.getItem("checkShopStoreId"),
            pageNo: this.queryInfo.pageNum,
            row: this.queryInfo.pageSize,
            synthesisSearch: synthesisSearch,
            synthesisOrderType: synthesisOrderType,
            repositoryId: localStorage.getItem("checkRepositoryId"),
            goodsCategoryId: goodsCategoryId,
          }).then((res) => {
            if (res.code == 1) {
              this.total = res.data.totalNum;
              this.shopStoreId = res.data.requestVo.shopStoreId;
              this.getRepositoryList();
            }
          });
        } else if (res.code == -1) {
          this.goodsList = [];
          this.goodList = {};
          this.$message.error("不存在此商品");
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    // handleCurrentChange(newVal) {
    //     this.queryInfo.pageNum = newVal
    //     if (this.status == 1) {
    //         this.getRepositoryGoodsDetailList(this.synthesisSearch, this.synthesisOrderType, this.repositoryId)
    //     } else {
    //         this.getRepositoryGoodsDetailList()
    //     }
    // },
    // handleSizeChange(newVal) {
    //     this.queryInfo.pageSize = newVal
    //     this.getRepositoryGoodsDetailList()
    // },
    // 新增加商品跳转
    addGoods() {
      this.cannotClear = 1;
      this.$router.push({
        path: "/invoicing/chooseAddGoods",
        query: { form: this.$route.query.form, goodsStyle: this.goodsStyle },
      });
    },
    // 更新进货价
    takePriceBlur(e) {
      // e.target.value = e.target.value.replace(/[^\d]/g,'')

      if (Number(e.target.value) > 99999.99) {
        e.target.value = "";
        this.$message.error("最大价格不可超过99999.99哦~");
        return;
      }

      if (e.target.value.length == 0) {
        return;
      }
      this.goodList.takePrice = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      updateTakePrice({
        isManager: 1,
        goodsId: this.goodList.goodsId,
        productId: this.goodList.productId,
        takePrice: this.goodList.takePrice,
      }).then((res) => {
        if (res.code == 1) {
          this.$forceUpdate();
          this.goodList.takePrice = this.goodList.takePrice;
          // this.goodList.takePrice = ""
        }
      });
    },
    // 改变添加好商品的数量
    handleChange(item) {
      // item.goodsNum = item.goodsNum.replace(/[^\d]/g,'')
      if (item.isInfiniteStock == 0) {
        this.maxNum = item.qrcTotalStockCount;
      } else {
        this.maxNum = 9999999999999;
      }
      if (this.goodsStyle == 3 || this.goodsStyle == 1) {
        this.maxNum = 9999999999999;
      }
      if (item.goodsNum == 0) {
        var index = this.confirmChooseList.findIndex((item1) => {
          return item1.productId == item.productId;
        });
        if (index !== -1) {
          this.confirmChooseList.splice(index, 1);
          localStorage.setItem(
            "confirmChooseList",
            JSON.stringify(this.confirmChooseList)
          );
          var trueList = this.confirmChooseList.filter((item) => {
            return item.click == true;
          });
          this.confirmChooseListLength = trueList.length;
        }
      }
      if (this.confirmChooseList.length == 0) {
        this.totalClick = false;
      }
      let reg = /^[0-9]\d*$/;
      if (item.unitType == 1) {
        if (!reg.test(item.goodsNum)) {
          this.$message({
            message: "计数商品不能为小数",
            duration: 1000,
            type: "error",
          });
          item.goodsNum = 1;
          // this.confirmChooseList = JSON.parse(localStorage.getItem("confirmChooseList" || "[]"))
          // this.$forceUpdate()
          return;
        }
      }
      this.totalMony = 0;
      this.confirmChooseList.forEach((item) => {
        if (item.click == true) {
          this.totalMony += item.takePrice * item.goodsNum;
        }
      });
      if (item.unitType == 2) {
        item.goodsNum = item.goodsNum.toFixed(3);
      }
      var index = this.confirmChooseList.findIndex((item1) => {
        return item1.productId == item.productId;
      });
      console.log(index);
      if (index !== -1) {
        this.confirmChooseList[index].goodsNum = item.goodsNum;
        localStorage.setItem("confirmChooseList", JSON.stringify(this.confirmChooseList));
      }
    },
    // 增加进货退货商品
    addRefundGoods() {
      if (this.goodsCategoryList.length == 0) {
        this.$message.warning("该仓库下无商品，请更换仓库");
        return;
      }
      // this.cannotClear = 1
      this.goodsDialogVisible = true;
      this.dialogVisible = true;
      this.mask = true;
      if (this.goodsCategoryList.length == 0) {
        this.dialogVisible = false;
      }
    },
    // 关闭进货退货商品
    closeImg() {
      this.goodsDialogVisible = false;
      this.dialogVisible = false;
      this.mask = false;
      if (this.synthesisSearch) {
        this.synthesisSearch = "";
        if (this.goodsStyle == 1) {
          this.getRepositoryGoodsDetailList(
            this.synthesisSearch,
            "",
            this.goodsCategoryId
          );
        } else {
          this.getRepositoryGoodsDetailList(
            this.synthesisSearch,
            "",
            this.goodsCategoryId,
            2
          );
        }
      }
    },
    // 获取分类列表
    getGoodsCategoryList(queryType) {
      goodsCategoryLists({
        isManager: 1,
        queryType: queryType,
        pageNo: 1,
        row: 999999,
        shopStoreId: localStorage.getItem("checkShopStoreId"),
        repositoryId: localStorage.getItem("checkRepositoryId"),
      }).then((res) => {
        if (res.code == 1) {
          this.goodsCategoryList = res.data;
          this.goodsCategoryList.unshift({
            categoryName: "全部商品",
            goodsCategoryId: "",
          });
          if (this.goodsStyle == 1) {
            this.getRepositoryGoodsDetailList(
              "",
              "",
              this.goodsCategoryList[0].goodsCategoryId
            );
          } else {
            this.getRepositoryGoodsDetailList(
              "",
              "",
              this.goodsCategoryList[0].goodsCategoryId,
              2
            );
          }
        } else if (res.code == -1) {
          this.$message.warning("该仓库下无商品");
        }
      });
    },
    // 选择分类下对应的商品
    chooseProducts(item, index) {
      console.log(item.goodsCategoryId, index);
      this.goodsCategoryId = item.goodsCategoryId;
      this.indexNumber = index;
      if (this.goodsStyle == 1) {
        this.getRepositoryGoodsDetailList("", "", item.goodsCategoryId);
      } else {
        this.getRepositoryGoodsDetailList("", "", item.goodsCategoryId, 2);
      }
    },
    // 选择要添加的商品
    chooseLists(item, index) {
      this.status = 1;
      console.log(item, index);
      var arr = item;
      if (this.goodsStyle == 3 || this.goodsStyle == 1) {
        this.goodList = arr;
        return;
      }
      if (arr.unitType == 1) {
        if (!arr.isInfiniteStock && arr.qrcTotalStockCount == 0) {
          this.$message({
            type: "warning",
            message: "库存不足",
          });
          return;
        }
      }
      this.goodList = arr;
    },
    handleChanges(value) {
      console.log(value, this.goodList);
      this.goodsNum = value;
    },
    // 完成
    confirmAdd() {
      console.log(this.goodList.unitType, "unitType");
      let reg = /^[1-9]\d*$/;
      if (this.goodList.unitType == 1) {
        if (!reg.test(this.goodsNum)) {
          this.$message({
            message: "计数商品不能为小数或者零",
            duration: 1000,
            type: "error",
          });
          this.goodsNum = 1;
          return;
        }
      }
      if (this.goodsNum == 0) {
        this.$message({
          message: "商品数量不能为零",
          duration: 1000,
          type: "error",
        });
        this.goodsNum = 1;
        return;
      }
      var arr = {
        goodsNum: "",
        goodsName: "",
        takePrice: "",
        isInfiniteStock: "",
        qrcTotalStockCount: "",
        maximumTotalStockCount: "",
        minimumTotalStockCount: "",
        goodsImage: "",
        valueContent: "",
        unitType: "",
        goodsUnit: "",
        click: false,
        goodsBarCode: "",
      };
      arr.goodsNum = this.goodsNum;
      arr.goodsName = this.goodList.goodsName;
      arr.takePrice = Math.max(this.goodList.takePrice, 0);
      arr.isInfiniteStock = this.goodList.isInfiniteStock;
      arr.qrcTotalStockCount = this.goodList.qrcTotalStockCount;
      arr.maximumTotalStockCount = this.goodList.maximumTotalStockCount;
      arr.minimumTotalStockCount = this.goodList.minimumTotalStockCount;
      arr.goodsImage = this.goodList.goodsImage;
      arr.valueContent = this.goodList.valueContent;
      arr.productId = this.goodList.productId;
      arr.unitType = this.goodList.unitType;
      arr.goodsId = this.goodList.goodsId;
      arr.goodsUnit = this.goodList.goodsUnit;
      arr.click = false;
      arr.goodsBarCode = this.goodList.goodsBarCode;

      if (this.goodsStyle == 3 || this.goodsStyle == 1) {
      } else {
        if (arr.isInfiniteStock == 0) {
          var idx = this.confirmChooseList.findIndex((item) => {
            return item.productId == arr.productId;
          });
          if (idx !== -1) {
            var goodNum = this.confirmChooseList[idx].goodsNum + 1;
          }
          // console.log(idx, 1111111, goodNum, arr.qrcTotalStockCount)
          if (arr.qrcTotalStockCount == 0 || goodNum > arr.qrcTotalStockCount) {
            this.$message.error(arr.goodsName + "库存不足");
            return;
          }
        }
      }

      if (this.confirmChooseList.length == 0) {
        this.confirmChooseList.unshift(arr);
        this.goodsNum = 1;
        this.$message({
          message: "添加商品成功",
          type: "success",
          duration: 1000,
        });
        localStorage.setItem("confirmChooseList", JSON.stringify(this.confirmChooseList));
      } else {
        var index = this.confirmChooseList.findIndex((item, index, array) => {
          return item.productId == this.goodList.productId;
        });
        console.log(index, "索引");
        if (index !== -1) {
          console.log("存在");
          this.confirmChooseList[index].goodsNum += this.goodsNum;
          // this.confirmChooseList[index].goodsNum = this.confirmChooseList[index].goodsNum.toFixed(3)
          localStorage.setItem(
            "confirmChooseList",
            JSON.stringify(this.confirmChooseList)
          );
          this.$forceUpdate();
          this.goodsNum = 1;
          this.$message({
            message: "添加商品成功",
            type: "success",
            duration: 1000,
          });
          return;
        } else {
          console.log("不存在");
          this.confirmChooseList.unshift(arr);
          this.confirmChooseList.every((item) => {
            return (this.totalClick = item.click);
          });
          this.goodsNum = 1;
          this.$message({
            message: "添加商品成功",
            type: "success",
            duration: 1000,
          });
          localStorage.setItem(
            "confirmChooseList",
            JSON.stringify(this.confirmChooseList)
          );
        }
      }
    },
    // 结算
    settleMent() {
      var idx = this.confirmChooseList.some((item) => {
        return item.click == true;
      });
      if (!idx) {
        this.$message.error("请先选择商品然后进行结算");
        return;
      }
      this.cannotClear = 1;
      this.$router.push({
        path: "/invoicing/chooseReturnGoods",
        query: { goodsStyle: this.goodsStyle },
      });
    },
    // 确认选择
    confirmAddGoods() {
      var idx = this.confirmChooseList.some((item) => {
        return item.click == true;
      });
      if (!idx) {
        this.$message.error("请先选择商品然后进行盘点");
        return;
      }
      this.cannotClear = 1;
      this.$router.push({
        path: "/invoicing/InventoryGoods",
        query: { goodsStyle: this.goodsStyle },
      });
    },
    // 调拨
    confirmChangeGoods() {
      var idx = this.confirmChooseList.some((item) => {
        return item.click == true;
      });
      if (!idx) {
        this.$message.error("请先选择商品然后进行调拨");
        return;
      }
      this.cannotClear = 1;
      this.$router.push({
        path: "/invoicing/goodsChangeAdd",
        query: { goodsStyle: this.goodsStyle },
      });
    },
    // 返回   取消
    back() {
      if (this.goodsStyle == 1) {
        this.$router.push("/invoicing/addGoodsPurchase");
      } else if (this.goodsStyle == 2) {
        this.$router.push("/invoicing/addGoodsPurchaseReturn");
      } else if (this.goodsStyle == 3) {
        this.$router.push("/invoicing/stockCheck");
      } else if (this.goodsStyle == 4) {
        this.$router.push("/invoicing/goodsChange");
      }
      localStorage.removeItem("confirmChooseList");
      localStorage.removeItem("chooseList");
    },
    // 保存扫码枪的状态
    scanSwithChange(e) {
      localStorage.setItem("addGoodsSwith", e);
    },
    // 扫码枪添加商品
    addScanSwitchGoods() {
      console.log(this.scanSwitch);
      if (this.scanSwitch == true) {
        console.log(11);
        this.goodsBarcodeScanner = createScannerInput({
          getValue: () => this.codeMsg,
          setValue: (value) => {
            this.codeMsg = value;
          },
          onEnter: () => {
            this.barCode = this.codeMsg;
            console.log(this.barCode, this.goodsList, "barCode");
            if (this.barCode.length == 0) {
              return;
            }
            var index = this.goodsList.findIndex((item) => {
              return item.goodsBarCode == this.barCode;
            });
            console.log(index);
            if (index !== -1) {
              this.goodList = this.goodsList[index];
              this.codeMsg = "";
              this.confirmAdd();
            } else {
              this.$message.error("不存在此商品");
            }
          },
        });
        document.onkeydown = this.goodsBarcodeScanner.handleKeydown;
      } else {
        console.log(22);
        document.onkeydown = null;
        if (this.goodsBarcodeScanner) {
          this.goodsBarcodeScanner.reset();
        }
      }
    },
  },
};
</script>

<style scoped>
.center {
  color: #707070;
  padding: 200px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navBlock_click {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #fff;
  width: 100%;
  height: 52px;
  line-height: 52px;
  text-align: center;
  border-bottom: 1px solid #f8f8f9;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  cursor: pointer;
}
.detail-box {
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #f6f6f6;
}
.category {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: rgba(248, 248, 248, 1);
  height: 52px;
  line-height: 52px;
  text-align: center;
  border-bottom: 1px solid #f8f8f9;
  background-color: #eee;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  cursor: pointer;
}
.left {
  width: 100px;
  max-height: 554px;
  overflow-y: scroll;
  background-color: rgba(248, 248, 248, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 0px 0px 0px 8px;
}
.right {
  margin-left: 25px;
  width: 552px;
  max-height: 554px;
  overflow-y: scroll;
}
.text-color {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  box-sizing: border-box;
  padding-right: 6px;
}
.closeImg {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 30px;
  top: 22px;
}
.scanner {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  padding-left: 20px;
  box-sizing: border-box;
}
.goods-detail {
  width: 516px;
  height: 468px;
  background: rgba(255, 255, 255, 1);
  z-index: 2;
  position: absolute;
  top: 250px;
  left: 1000px;
  border-radius: 10px;
  padding: 24px 23px;
  box-sizing: border-box;
}
.mt5 {
  margin-top: 5px;
}
.mt20 {
  margin-top: 20px;
}
.ml69 {
  margin-left: 69px;
}
.goodsPic {
  width: 185px;
  height: 175px;
  border-radius: 5px;
}
.goodsTitle {
  width: 246px;
  height: 47px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.goodsDetail {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  padding-top: 28px;
  box-sizing: border-box;
}
.goods-header {
  width: 687px;
  height: 60px;
  background: rgba(248, 248, 249, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 8px 8px 0px 0px;
  padding: 15px 20px;
  box-sizing: border-box;
}
.goods {
  width: 687px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  z-index: 2;
  position: absolute;
  top: 250px;
  left: 290px;
}
.mask {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(101, 101, 101, 0.6);
}
.reduce {
  width: 20px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #f2f2f2;
  background-color: #f2f2f2;
  margin-top: 32px;
  box-sizing: border-box;
  text-align: center;
  color: #ccc;
  cursor: pointer;
}
.add {
  width: 20px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #118eea;
  background-color: #118eea;
  color: #fff;
  margin-top: 32px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
}
.highStock {
  display: inline-block;
  width: 30px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #f77b7c;
  color: #f77b7c;
  font-size: 12px;
}
.lowStock {
  display: inline-block;
  width: 30px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #fa7e31;
  color: #fa7e31;
  font-size: 12px;
}
.color {
  color: #c6c6c6;
  font-size: 14px;
  padding-left: 10px;
  box-sizing: border-box;
}
.img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 10px;
}
.goodsBox {
  border-bottom: 1px solid #e2e2e2;
  width: calc(100vw - 280px);
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(226, 226, 226, 1);
}
.flex-centers {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  box-sizing: border-box;
}
.box {
  width: 100%;
  background-color: #f8f8f8;
  height: 70px;
  line-height: 70px;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.checked {
  padding: 20px;
  box-sizing: border-box;
}
.commidityClick {
  position: relative;
  top: -18px;
}
.el-checkbox {
  margin-right: 6px !important;
}
.searchGroup {
  /* max-height: 700px; */
  /* overflow-y: scroll; */
  height: 100%;
  width: 100%;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.left::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.left::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.left::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.right::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.right::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.right::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
